//
//  @see https://codepen.io/ezra_siton/pen/XNpJaX
//  @see https://swiperjs.com/get-started
//  @see https://photoswipe.com/documentation/getting-started.html
//  @see https://photoswipe.com/documentation/options.html
//
//  NOTES
//
//  1.  Removed Ezra Siton code to stop Swiper autoplay (site does not use autoplay)
//
//  TOC
//
//  1.    Swiper initialization
//  2.    PhotoSwipe initialization
//  2.1.  PhotoSwipe options
//  2.2.  Swiper and Photoswipe cooperation
//

import PhotoSwipe from 'photoswipe';
import PhotoSwipeUIDefault from 'photoswipe/dist/photoswipe-ui-default';

import SwiperCore, {
  A11y,
  EffectFade,
  Navigation,
  Pagination,
} from 'swiper/core';

SwiperCore.use([A11y, EffectFade, Navigation, Pagination]);

const sliders = document.querySelectorAll('.c-slider');

//  ------------------------------------------------------------------------  \\
//                                                                            \\
//  1.  Swiper initialization                                                 \\
//                                                                            \\
//  ------------------------------------------------------------------------  \\

const swiperGallery = new SwiperCore('.c-slider', {
  a11y: {
    enabled: true,
  },
  centeredSlides: true,
  keyboard: {
    enabled: true,
  },
  loop: true,
  loopedSlides: 3,
  pagination: {
    el: '.swiper-pagination',
  },
  slidesPerView: 'auto',
  spaceBetween: 4,
  breakpoints: {
    1025: {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: false,
    },
  },
});

//  ------------------------------------------------------------------------  \\
//                                                                            \\
//  2.  Photoswipe initialization                                             \\
//                                                                            \\
//  ------------------------------------------------------------------------  \\

const photoswipeLightbox = (gallerySelector) => {
  if (sliders.length < 1) {
    return;
  }

  //
  //
  //  Parse slide data (url, title, size ...) from DOM elements (children of gallerySelector)
  //
  //
  const parseThumbnailElements = (el) => {
    const thumbElements = el.childNodes;
    const numNodes = thumbElements.length;
    const items = [];
    let figureEl;
    let linkEl;
    let size;
    let item;

    for (let i = 0; i < numNodes; i += 1) {
      figureEl = thumbElements[i]; // <figure> element

      //  Include only element nodes
      if (figureEl.nodeType === 1) {
        //  eslint-disable-next-line prefer-destructuring
        linkEl = figureEl.children[0];

        size = linkEl.getAttribute('data-size').split('x');

        //
        //  Create slide object
        //
        item = {
          src: linkEl.getAttribute('href'),
          w: parseInt(size[0], 10),
          h: parseInt(size[1], 10),
        };

        if (figureEl.children.length > 1) {
          // <figcaption> content
          item.title = figureEl.children[1].innerHTML;
        }

        if (linkEl.children.length > 0) {
          //  <img> thumbnail element, retrieving thumbnail url
          item.msrc = linkEl.children[0].getAttribute('src');
        }

        //  Save link to element for getThumbBoundsFn
        item.el = figureEl;
        items.push(item);
      }
    }

    return items;
  };

  //
  //
  //  Triggers when user clicks on thumbnail
  //
  //

  const onThumbnailsClick = (e) => {
    e.preventDefault();

    const eTarget = e.target;

    //
    //  Find root element of slide
    //

    const clickedListItem = eTarget.closest('.swiper-slide-active');

    // const clickedListItem = closest(eTarget, (el) => {
    //   //  Original (from PhotoSwipe Getting Started) checks for LI element here.
    //   //  I check for FIGURE instead, since this is the element I use.
    //   //  The additional check for the Swiper class is to make sure
    //   //  that only the active slide opens the lightbox.
    //   return (
    //     // el.tagName &&
    //     // el.tagName.toUpperCase() === 'FIGURE' &&
    //     el.classList.contains('swiper-slide-active')
    //   );
    // });

    if (!clickedListItem) {
      return;
    }

    //  Find index of clicked item by looping through all child nodes.
    //  Alternatively, you may define index via data- attribute.
    const clickedGallery = clickedListItem.parentNode;
    const { childNodes } = clickedListItem.parentNode;
    const numChildNodes = childNodes.length;
    let nodeIndex = 0;
    let index;

    for (let i = 0; i < numChildNodes; i += 1) {
      if (childNodes[i].nodeType === 1) {
        if (childNodes[i] === clickedListItem) {
          index = nodeIndex;
          break;
        }

        nodeIndex += 1;
      }
    }

    if (index >= 0) {
      //
      //  Open PhotoSwipe if valid index found
      //

      //  eslint-disable-next-line no-use-before-define
      openPhotoSwipe(index, clickedGallery);
    }

    //  eslint-disable-next-line consistent-return
    return false;
  };
  //
  //  END OF onThumbnailsClick()
  //

  //
  //
  //  Parse picture index and gallery index from URL (#&pid=1&gid=2)
  //
  //

  const photoswipeParseHash = () => {
    const hash = window.location.hash.substring(1);
    const params = {};

    if (hash.length < 5) {
      return params;
    }

    const vars = hash.split('&');

    for (let i = 0; i < vars.length; i += 1) {
      if (!vars[i]) {
        //  eslint-disable-next-line no-continue
        continue;
      }

      const pair = vars[i].split('=');

      if (pair.length < 2) {
        //  eslint-disable-next-line no-continue
        continue;
      }

      //  eslint-disable-next-line prefer-destructuring
      params[pair[0]] = pair[1];
    }

    if (params.gid) {
      params.gid = parseInt(params.gid, 10);
    }

    return params;
  };

  //
  //
  //
  //
  //

  const openPhotoSwipe = (index, galleryElement, disableAnimation, fromURL) => {
    const pswpElement = document.querySelectorAll('.pswp')[0];
    //  let options;
    //  let gallery;
    //  let items;

    const items = parseThumbnailElements(galleryElement);

    //  ----------------------------------------------------------------  \\
    //                                                                    \\
    //  2.1.  PhotoSwipe options                                          \\
    //                                                                    \\
    //  @see  https://photoswipe.com/documentation/options.html           \\
    //                                                                    \\
    //  ----------------------------------------------------------------  \\

    const options = {
      //  Buttons/elements
      //
      closeEl: true,
      captionEl: true,
      fullscreenEl: false,
      zoomEl: false,
      shareEl: false,
      counterEl: false,
      arrowEl: true,
      preloaderEl: true,

      //
      //  Following advice in second answer under implementation:
      //  @see https://photoswipe.com/documentation/faq.html
      //
      showHideOpacity: true,

      bgOpacity: 0.8125,

      //  Define gallery index (for URL)

      galleryUID: galleryElement.getAttribute('data-pswp-uid'),
      //  eslint-disable-next-line no-shadow
      getThumbBoundsFn(index) {
        //
        //  See Options -> getThumbBoundsFn section of documentation for more info.
        //
        const thumbnail = items[index].el.getElementsByTagName('img')[0]; // find thumbnail
        const pageYScroll =
          window.scrollY || document.documentElement.scrollTop;
        const rect = thumbnail.getBoundingClientRect();

        return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
      },
    };

    //
    //  PhotoSwipe opened from URL
    //
    if (fromURL) {
      if (options.galleryPIDs) {
        //
        //  Parse real index when custom PIDs are used
        //  http://photoswipe.com/documentation/faq.html#custom-pid-in-url
        //
        for (let j = 0; j < items.length; j += 1) {
          if (items[j].pid === index) {
            options.index = j;
            break;
          }
        }
      } else {
        //  In URL indexes start from 1
        options.index = parseInt(index, 10) - 1;
      }
    } else {
      options.index = parseInt(index, 10);
    }

    //
    //  Exit if index not found
    //

    //  eslint-disable-next-line no-restricted-globals
    if (isNaN(options.index)) {
      return;
    }

    if (disableAnimation) {
      options.showAnimationDuration = 0;
    }

    //
    //  Pass data to PhotoSwipe and initialize it
    //
    const gallery = new PhotoSwipe(
      pswpElement,
      PhotoSwipeUIDefault,
      items,
      options,
    );

    gallery.init();

    //  ----------------------------------------------------------------  \\
    //                                                                    \\
    //  2.2.  PhotoSwipe and Swiper cooperation                           \\
    //                                                                    \\
    //  ----------------------------------------------------------------  \\

    //
    //  On unbindEvents (which triggers before closing animation)
    //  update Swiper position to the current zoom_in image (better UI)
    //
    //  TODO - 2021-07-27
    //  Make this work for multiple galleries too! And then remove condition.
    //
    if (sliders.length < 2) {
      gallery.listen('unbindEvents', () => {
        const getCurrentIndex = gallery.getCurrentIndex();
        swiperGallery.slideTo(getCurrentIndex, 0, false);
      });
    }
  };

  //
  //  Loop through all gallery elements and bind events
  //
  const galleryElements = document.querySelectorAll(gallerySelector);

  for (let i = 0, l = galleryElements.length; i < l; i += 1) {
    galleryElements[i].setAttribute('data-pswp-uid', i + 1);
    galleryElements[i].onclick = onThumbnailsClick;
  }

  //
  //  Parse URL and open gallery if it contains #&pid=3&gid=1
  //
  const hashData = photoswipeParseHash();

  if (hashData.pid && hashData.gid) {
    openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
  }
};

//
//  Execute above function
//
photoswipeLightbox('.c-slider__wrapper');

export default photoswipeLightbox;
